export const VueFuncallPlugin = {
    install(app) {
        VueFuncallPlugin._context = app._context;
    },
    _context: null
};
